import { useMemo } from "react";
import { getClosestTimestamp } from "../utils/timeUtils.js";

export function useStationaryEffect(stationaryPoints, currentTime,coverages,Opacity,Type,isActive,playbackSpeed) {
  
  
  const activeHistories = useMemo(() => {
    if (!isActive) {
      // フラグが無効な場合は以前の結果を返すか、デフォルト値を返す
      return [];
    }



    if (!stationaryPoints || stationaryPoints.length === 0) return [];

    const BASE_LIFETIME = 10**10/playbackSpeed**1.7; // 円の最大生存時間 (ミリ秒)

    const MIN_CIRCLES = 1; // 最小上限
    const MAX_CIRCLES = 100; // 最大上限



    // 再生速度に応じて最大保持上限をスケール (線形補間)
    const MAX_CIRCLES_PER_POINT = Math.round(
      MIN_CIRCLES +
        (MAX_CIRCLES - MIN_CIRCLES) *
          Math.min(1, Math.max(0, (playbackSpeed - 1) / 9)) // playbackSpeed 1～10 に正規化
    );

        // Ease-In (加速) 関数
    const easeIn = (t) => t * t;

    // Ease-Out (減速) 関数
    const easeOut = (t) => t * (2 - t);

    // Ease-In-Out (加速後減速) 関数
    const easeInOut = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
    


    // 各 stationaryPoint ごとに処理
    let histories = stationaryPoints.flatMap((point) => {
  // 現在の最大半径を追跡
  let currentMaxRadius = 0;
    


      // 各 timestamp ごとにエフェクトを生成
      const pointHistories = point.timestamps.map((timestamp) => {
  
          const elapsedTime = currentTime - timestamp;

          // 時間差が負の場合はまだ開始していないためスキップ
          
          if (elapsedTime < 0 || elapsedTime > BASE_LIFETIME) {
                      return null;
                    }

          const scale=2

          const expandDuration = 1*playbackSpeed*scale; // 膨張する秒数
          const shrinkDuration =1*playbackSpeed*scale; // 収縮する秒数
          let maxRadius = (point.route_type === 3) ? coverages.busCoverage : coverages.trainCoverage; // 最大半径 ※route_type 2が電車 3がバス
          let radius = 0;

          if (elapsedTime>BASE_LIFETIME){
            return null
          }


          if (elapsedTime <= expandDuration) {
            // 膨張フェーズ
            const progress = elapsedTime / expandDuration; // 正規化（0.0〜1.0）
            radius = maxRadius * easeInOut(progress); // Ease-Out を適用
            //radius = (maxRadius * elapsedTime) / expandDuration;
          
          

          } else if (elapsedTime <= expandDuration + shrinkDuration) {

           
            // 収縮フェーズ
            const shrinkTime = elapsedTime - expandDuration;

            const progress = shrinkTime / shrinkDuration; // 正規化（0.0〜1.0）
            radius = maxRadius * (1 - easeIn(progress)); // Ease-In を適用


            //radius = maxRadius - (maxRadius * shrinkTime) / shrinkDuration;
          } else {
            // エフェクト終了
            return null; // 終了したエフェクトをスキップ
          }

           // 半径が現在の最大半径以下の場合はスキップ
          if (radius <= currentMaxRadius) {
            return null;
          }

          // 最大半径を更新
          currentMaxRadius = radius;


          // history データの形式に変換
          return {
            lat: point.stop_lat,
            lng: point.stop_lon,
            r: Math.max(radius, 0), // 半径は0以上
            color:point.route_color,
            opacity:Opacity,
            type:Type,
          };
        })
        .filter(Boolean); // 無効なエフェクトを除外

        // 上限を超えた場合は古いものから削除
      if (pointHistories.length > MAX_CIRCLES_PER_POINT) {
        pointHistories.sort((a, b) => a.timestamp - b.timestamp); // 古い順にソート
        return pointHistories.slice(-MAX_CIRCLES_PER_POINT); // 最新の MAX_CIRCLES_PER_POINT 個を保持
      }

      return pointHistories;
    
    });

    // 古い円から削除
    // if (histories.length > MAX_CIRCLES) {
    //   histories = histories
    //     .sort((a, b) => a.timestamp - b.timestamp) // 古い順にソート
    //     .slice(-MAX_CIRCLES); // 最新の MAX_CIRCLES 個を保持
    // }

    return histories;


  }, [stationaryPoints, currentTime]);



  // 各エフェクトの history を1つの配列にまとめて返す
  return activeHistories.map((effect) => [effect]);
}
